module.exports = __webpack_public_path__ + "static/media/puzzle-2891875_1280.422cf5f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/puzzle-2891875_1280.jpg
// module id = 462
// module chunks = 0